import { Component, ViewModel, View } from "binder";
import { getAsBoolean } from "../utilities";
import  { LoadingView } from "./loading-view"

export class LoadingViewModel extends Component{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    GetDefaultView(): View <ViewModel> {
        return new LoadingView();
    }
    public getTypeId(): string {
        return "VM-B3B622FA-8A5C-4D53-8619-A38CC485E67F"
    }
    public set isloading(v: boolean) { this._isloading = getAsBoolean(v); } public get isloading(): boolean { return this._isloading;} private _isloading: boolean;
        
}
